import { RootEpic } from 'MyTypes';
import { from, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { surveyService } from '@portal/common/services/api/survey';
import { PaginatedResponse, SurveyResource } from '@portal/common/types';

import { getOrganizationAsync } from '../organization/actions';
import { dismissSurvey } from '../user-settings/actions';
import { getSurveysAsync } from './actions';

export const loadSurveys: RootEpic = (action$) =>
    action$.pipe(
        filter(isActionOf([getOrganizationAsync.success])),
        switchMap(() =>
            from(surveyService.getMyOrganizationSurveys()).pipe(
                map((res: PaginatedResponse<SurveyResource>) =>
                    getSurveysAsync.success(res.results)
                ),
                catchError((message: string) => of(getSurveysAsync.failure(message)))
            )
        )
    );

export const dismissSurveyEpic: RootEpic = (action$) =>
    action$.pipe(
        filter(isActionOf(dismissSurvey)),
        switchMap((action) =>
            from(surveyService.submitSurveyResponse(action.payload)).pipe(
                switchMap(() =>
                    from(surveyService.getMyOrganizationSurveys()).pipe(
                        map((res) => getSurveysAsync.success(res.results)),
                        catchError((err: string) => of(getSurveysAsync.failure(err)))
                    )
                ),
                catchError((err: string) => {
                    console.error('Dismiss survey failed:', err);
                    return of();
                })
            )
        )
    );
